import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  statusColumnContainer: {
    height: 25,
  },
  statusType: {
    display: 'block',
    width: 100,
  },
  rowBaseStyle: { borderLeft: `5px solid transparent` },
}));
